import type { ITooltipParams } from 'ag-grid-community'

const getRawValueTooltip = ({ value }: Pick<ITooltipParams, 'value'>) => {
  if (value == null || value === '') {
    return undefined
  }

  if (typeof value === 'string') {
    return value
  }

  if (typeof value === 'object') {
    try {
      return JSON.stringify(value)
    } catch {
      return String(value)
    }
  }

  return String(value)
}

export default getRawValueTooltip
